import { cssTransition, toast, ToastContainer, ToastContent, ToastOptions } from "react-toastify";
import { styled } from "@mui/material/styles";
import { externalUrls } from "@portal/app/_common/lib/urls";

const Slide = cssTransition({
  enter: "animate__animated animate__slideInRight",
  exit: "animate__animated animate__slideOutRight",
});

export const FALLBACK_ERROR_MESSAGE = (
  <>
    <p>Something went wrong, please try again.</p>
    <p>
      If the problem persists, please reach out to{" "}
      <a href={externalUrls.MailToEmail} target="_blank" rel="noreferrer">
        support@dreambound.com
      </a>
    </p>
  </>
);

export const ToastProvider = ({ children }: React.PropsWithChildren) => (
  <>
    <DreamToastContainer position="top-right" autoClose={false} transition={Slide} closeOnClick />
    {children}
  </>
);

const DEFAULT_OPTIONS: ToastOptions = {
  autoClose: 3000,
  hideProgressBar: true,
  draggable: false,
  theme: "colored",
};

export type ToastFunction = (content: ToastContent, options?: ToastOptions) => string | number;

export const successToast: ToastFunction = (message, options = {}) =>
  toast.success(message, { ...DEFAULT_OPTIONS, ...options });

export const errorToast: ToastFunction = (message, options = {}) =>
  toast.error(message, {
    ...DEFAULT_OPTIONS,
    autoClose: 5000,
    ...options,
  });

export const infoToast: ToastFunction = (message, options = {}) =>
  toast.info(message, { ...DEFAULT_OPTIONS, ...options });

// These variables are used to theme Toastify as detailed here:
// https://fkhadra.github.io/react-toastify/how-to-style/
const DreamToastContainer = styled(ToastContainer)`
  --animate-duration: 0.2s;
  --toastify-color-success: ${({ theme }) => theme.palette.success.main};
  --toastify-color-error: ${({ theme }) => theme.palette.error.dark};
  --toastify-color-info: ${({ theme }) => theme.palette.primary.dark};
  @media screen and (max-width: 480px) {
    --toastify-toast-bd-radius: 0;
  }
`;
